import Charts from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { LINE_CHART_1 } from "../../../Data/Widgets/ChartWidgets";
import { H4, H6 } from "../../../AbstractElements";
import { CompareLastMonth, TotalSaleHeading } from "../../../Constant";

const TotalSale = () => {
  return (
    <Col xl="4" md="12" className="box-col-4">
      <Card className="o-hidden">
        <div className="chart-widget-top">
          <CardBody className="row pb-0 m-0">
            <Col xl="9" lg="8" xs="9" className="p-0">
              <H6 className="mb-2">{TotalSaleHeading}</H6>
              <H4>$3654.00</H4>
              <span>{CompareLastMonth}</span>
            </Col>
            <Col xl="3" lg="4" xs="3" className="text-end p-0">
              <H6 className="txt-success">+65%</H6>
            </Col>
          </CardBody>
          <div>
            <div id="chart-widget1">
              <Charts options={LINE_CHART_1} series={LINE_CHART_1.series} height="170" type="area" />
            </div>
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default TotalSale;
